'use strict';
var FIVE_MINUTES_IN_MS, checkCurrentLocation, cllCookie, detectCurrentLocation, error, errorCallback, getSearchLocCookie, intervalID, ref, setCLLTimer, setELLCookie, setSearchLocCookie, success, successCallback, updateCurrentLocation,
  slice = [].slice;

ref = require('./m_location_helper'), cllCookie = ref.cllCookie, getSearchLocCookie = ref.getSearchLocCookie, setSearchLocCookie = ref.setSearchLocCookie, setELLCookie = ref.setELLCookie;

successCallback = errorCallback = intervalID = void 0;

FIVE_MINUTES_IN_MS = 1000 * 60 * 5;


/**
 * HTML5 Geolocation API success callback
 *
 * @callback success
 * @param   {Object}   position        - Position information returned by Geolocation API
 * @returns {function} successCallBack - Callback to proceed in the search form submit
 */

success = function(position) {
  var lat, lng, ref1;
  ref1 = position != null ? position.coords : void 0, lat = ref1.latitude, lng = ref1.longitude;
  Groupon.Utils.trackEvent('client-geolocate-successful', {
    lat: lat,
    lng: lng
  });
  if (intervalID) {
    clearInterval(intervalID);
  }
  intervalID = setInterval(updateCurrentLocation, FIVE_MINUTES_IN_MS);
  cllCookie.set(position);
  return typeof successCallback === "function" ? successCallback({
    lat: lat,
    lng: lng,
    current: true
  }) : void 0;
};


/**
 * HTML5 Geolocation API error callback
 *
 * @callback error
 * @param   {Object}   err           - Error object returned by Geolocation API
 * @returns {Function} errorCallback - Callback to exit search form submit
 */

error = function(err) {
  Groupon.Utils.trackEvent('client-geolocate-failed', err);
  cllCookie.remove(err);
  return typeof errorCallback === "function" ? errorCallback(err) : void 0;
};


/**
 * Function to set the timer for CLL
 */

setCLLTimer = function() {
  var TTL, currentTime;
  currentTime = Date.now();
  TTL = (typeof localStorage !== "undefined" && localStorage !== null ? localStorage.getItem('cll_TTL') : void 0) || Cookie.get('cll_TTL') || currentTime;
  if (currentTime >= TTL) {
    return updateCurrentLocation();
  } else {
    return setTimeout(updateCurrentLocation, TTL - currentTime);
  }
};


/**
 * Function to keep location user updated when they are in "Current location"
 */

updateCurrentLocation = function() {
  var isCurrentLocation, nearMeTranslation, ref1, ref2, ref3, ref4, ref5, search_loc, touch_location, updateLocationCookies;
  search_loc = getSearchLocCookie();
  touch_location = (function() {
    try {
      return JSON.parse(decodeURIComponent(Cookie.get('touch_location')));
    } catch (error1) {
      return {};
    }
  })();
  nearMeTranslation = (ref1 = Groupon.LS) != null ? (ref2 = ref1.translations) != null ? (ref3 = ref2.search) != null ? ref3.nearme : void 0 : void 0 : void 0;
  updateLocationCookies = ((ref4 = Groupon.LS) != null ? (ref5 = ref4.flags) != null ? ref5.updateLocationCookies : void 0 : void 0) || false;
  isCurrentLocation = ((search_loc != null ? search_loc.friendlyName : void 0) === nearMeTranslation) || (touch_location != null ? touch_location.current : void 0);
  if (updateLocationCookies && isCurrentLocation) {
    return detectCurrentLocation(function(arg1) {
      var lat, lng, updateCookies;
      lat = arg1.lat, lng = arg1.lng;
      updateCookies = function(arg2) {
        var divisionId;
        divisionId = arg2.divisionId;
        search_loc = Object.assign(search_loc, {
          lat: lat,
          lng: lng,
          closestDivision: divisionId
        });
        setSearchLocCookie(search_loc);
        Groupon.Utils.setSiteCookies({
          'division': divisionId
        });
        return setELLCookie(lat + ',' + lng);
      };
      return Groupon.Utils.ClosestDivision.getClosestDivision({
        loc: '',
        lat: lat,
        lng: lng,
        success: updateCookies,
        error: function() {}
      });
    });
  } else {
    return detectCurrentLocation();
  }
};


/**
 * Function to determine parameters for HTML5 Geolocation API
 *
 * @param {Object}   [positionOptions] - Configuration  of Geolocation API (Optional)
 * @param {Function} [successCB]       - Callback for successful geolocation (Optional)
 * @param {Function} [errorCB]         - Callback for failed geolocation (Optional)
 */

checkCurrentLocation = function(positionOptions, successCB, errorCB) {
  if (positionOptions == null) {
    positionOptions = {};
  }
  if (successCB == null) {
    successCB = cllCookie.set;
  }
  if (errorCB == null) {
    errorCB = cllCookie.remove;
  }
  if (positionOptions.maximumAge || positionOptions.timeout) {
    navigator.geolocation.getCurrentPosition(successCB, errorCB, positionOptions);
  } else {
    navigator.geolocation.getCurrentPosition(successCB, errorCB);
  }
};


/**
 * Function to determine parameters for HTML5 Geolocation API
 *
 * @param {Function[]} arg                   - Splat of arguments containing success and error function
 * @param {Function}   arg[].successCallback - Callback for successful geolocation (Optional)
 * @param {Function}   arg[].errorCB         - Callback for failed geolocation (Optional)
 */

detectCurrentLocation = function() {
  var arg, positionOptions, ref1;
  arg = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  successCallback = arg[0], errorCallback = arg[1];
  if (!navigator.geolocation) {
    return typeof errorCallback === "function" ? errorCallback() : void 0;
  }
  positionOptions = ((ref1 = Groupon.LS.options) != null ? ref1.geolocationOptions : void 0) || {};
  return checkCurrentLocation(positionOptions, success, error);
};

module.exports = {
  checkCurrentLocation: checkCurrentLocation,
  currentLocationSuccess: success,
  currentLocationError: error,
  detectCurrentLocation: detectCurrentLocation,
  setCLLTimer: setCLLTimer
};

